const BACKEND_ORIGIN = typeof window !== 'undefined'
  ? window.location.origin
  : (process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '');

export const API = `${BACKEND_ORIGIN}/api`;

export const withBackendOrigin = (url = '') => {
  if (!url || typeof url !== 'string') return url;
  if (url.startsWith('/')) return `${BACKEND_ORIGIN}${url}`;
  return url;
};

export const remapProductImageUrl = (url = '') => {
  if (!url || typeof url !== 'string') return url;
  try {
    const parsed = new URL(url, BACKEND_ORIGIN || 'https://www.waysidemaplefarm.com');
    const match = parsed.pathname.match(/^\/api\/uploads\/([^/?#]+)$/);
    if (match) {
      return `/uploads/${match[1]}`;
    }
    return url;
  } catch {
    const match = url.match(/^\/api\/uploads\/([^/?#]+)$/);
    if (match) {
      return `/uploads/${match[1]}`;
    }
    return url;
  }
};

export const normalizeRenderableImageUrl = (url = '') => remapProductImageUrl(withBackendOrigin(url));
